import React from 'react'
import QuizzesPartial from '../../pages-partial/Quizzes'

const Quizzes = () => {
  return (
    <div><QuizzesPartial /></div>
  )
}

export default Quizzes